import React from 'react';
import { ArrowRightIcon, LockIcon, ZapIcon, SmartphoneIcon, PrinterIcon, CheckIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { useGeoPrice } from '../hooks/useGeoPrice';
import { bonusesTotalValue } from '../data/bonuses';
import { CHECKOUT_URL } from '../utils/links';
import { trackPixelEvent } from '../utils/metaPixel';
import { SectionHeading } from './SectionHeading';
interface IncludedItem {
  label: string;
  free?: boolean;
}
const included: IncludedItem[] = [{
  label: 'Guía completa Armonía Interior (10 módulos)'
}, {
  label: 'Bonus 01 · Mapa Bagua Visual + Plantilla para tu Hogar',
  free: true
}, {
  label: 'Bonus 02 · Guía de Activación de las 9 Áreas del Bagua',
  free: true
}, {
  label: 'Bonus 03 · Cuaderno Mi Casa, Mi Energía',
  free: true
}, {
  label: 'Bonus 04 · 50 Cambios de Feng Shui sin Gastar Dinero',
  free: true
}, {
  label: 'Bonus 05 · Póster Mapa Bagua imprimible',
  free: true
}];
const perks = [{
  icon: LockIcon,
  label: 'Compra 100% segura'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: SmartphoneIcon,
  label: 'Leelo en cualquier dispositivo'
}, {
  icon: PrinterIcon,
  label: 'Material imprimible'
}];
export function Offer() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(1800);
  const {
    price,
    regularPrice,
    isLoading
  } = useGeoPrice();
  const units = [{
    value: hours,
    label: 'Horas'
  }, {
    value: minutes,
    label: 'Minutos'
  }, {
    value: seconds,
    label: 'Segundos'
  }];
  return <section id="oferta" className="scroll-mt-20 bg-night" data-id="element-200" data-mp="bqpvzzszn6iw">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-201" data-mp="ftcsie0ltfmf">
        <SectionHeading eyebrow="Oferta de lanzamiento" title={<>
              Empezá hoy a transformar tu hogar con{' '}
              <span className="text-clay" data-id="element-203" data-mp="3k7km0eooswfk">Armonía Interior</span>
            </>} subtitle="Accedé a la guía completa y llevate hoy los 5 recursos adicionales sin costo." tone="dark" data-id="element-202" data-mp="kkvz6cp7zfrv" />

        <div className="mx-auto mt-10 flex max-w-[320px] items-center justify-center gap-3 sm:max-w-sm sm:gap-4" data-id="element-204" data-mp="vez0anxon90c">
          {units.map(unit => <div key={unit.label} className="flex-1 rounded-xl border border-white/10 bg-white/[0.06] px-2 py-3.5 text-center" data-id="element-205" data-mp="qg4inpbgbqht">
              <span className="block font-display text-[28px] font-semibold leading-none tabular-nums text-white sm:text-[32px]" data-id="element-206" data-mp="157d37k0hylo3">
                {unit.value}
              </span>
              <span className="mt-2 block text-[9.5px] uppercase tracking-[0.16em] text-white/50 sm:text-[10px]" data-id="element-207" data-mp="ch4ueirupdm6">
                {unit.label}
              </span>
            </div>)}
        </div>

        <div className="mx-auto mt-10 max-w-3xl overflow-hidden rounded-3xl bg-paper shadow-lift sm:mt-12" data-id="element-208" data-mp="livyxkanneeg">
          <div className="grid gap-9 p-6 sm:p-10 lg:grid-cols-[0.78fr_1fr] lg:items-center lg:gap-12" data-id="element-209" data-mp="hi2b0qx7pzlk">
            <img src="https://cdn.magicpatterns.com/uploads/1U536K5jSmmTxEQJ4pCPvK/mock_up_armonia_interior.webp" alt="Guía Armonía Interior con sus cinco bonus incluidos" className="mx-auto w-full max-w-[260px] rounded-xl shadow-soft sm:max-w-[320px] lg:max-w-none" loading="lazy" data-id="element-210" data-mp="1wyszk5ruvmri" />

            <div data-id="element-211" data-mp="25f1qtxkb8ynf">
              <p className="eyebrow text-[10px] text-clay" data-id="element-212" data-mp="25bdxayev8c8p">Todo lo que recibís</p>
              <ul className="mt-4 space-y-3" data-id="element-213" data-mp="1qiaobffcb6tl">
                {included.map(item => <li key={item.label} className="flex items-start gap-3" data-id="element-214" data-mp="1vgly5q5mxhbt">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage-tint" aria-hidden="true" data-id="element-215" data-mp="2j4lpar6uz9qx">
                      <CheckIcon className="h-3 w-3 text-sage-deep" strokeWidth={3} data-id="element-216" data-mp="2o3ox2je83u2l" />
                    </span>
                    <span className="text-[14px] leading-snug text-ink sm:text-[15px]" data-id="element-217" data-mp="29f277nqyzjx4">
                      {item.label}
                      {item.free ? <span className="ml-2 inline-block rounded-full bg-clay px-2 py-0.5 align-middle text-[9.5px] font-bold uppercase tracking-[0.12em] text-white" data-id="element-218" data-mp="3249d57sr7bse">
                          Gratis
                        </span> : null}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-8 border-t border-sage-line pt-7" data-id="element-219" data-mp="1e6s1senj7iq0">
                <p className="text-[13px] text-ink-mute" data-id="element-220" data-mp="1e9o0443ak9ez">
                  Precio regular <span className="line-through" data-id="element-221" data-mp="198qhjqedddcy">{regularPrice}</span> · bonus por{' '}
                  <span className="line-through" data-id="element-222" data-mp="14af8hhvwf6vs">{bonusesTotalValue}</span> incluidos gratis
                </p>
                <p className="mt-2.5 font-display text-[44px] font-semibold leading-none text-ink sm:text-[56px]" aria-live="polite" data-id="element-223" data-mp="21wcjyvbv2by8">
                  {price}
                  {isLoading ? <span className="ml-2 align-middle font-sans text-[12px] font-normal text-ink-mute" data-id="element-224" data-mp="1s618mnpul0hb">
                      detectando tu país…
                    </span> : null}
                </p>
                <p className="mt-3 text-[13px] font-medium text-sage-deep" data-id="element-225" data-mp="2kof6uof3iogx">
                  Pago único · Acceso inmediato · Sin suscripciones
                </p>

                <a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout', {
                content_name: 'Armonía Interior',
                value: price
              })} className="mt-7 flex items-center justify-center gap-2.5 rounded-xl bg-clay px-6 py-5 text-center text-[14.5px] font-semibold uppercase tracking-[0.09em] text-white shadow-cta transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-clay-dark sm:text-base" data-id="element-226" data-mp="2o5ksatjqxq3t">
                  Quiero mi acceso ahora
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-227" data-mp="3b4z3t4zvfs5l" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <ul className="mx-auto mt-9 grid max-w-3xl grid-cols-2 gap-4 sm:mt-10 sm:grid-cols-4" data-id="element-228" data-mp="3fytmq67nk33m">
          {perks.map(perk => <li key={perk.label} className="flex flex-col items-center gap-2 text-center" data-id="element-229" data-mp="3puwwny8qx614">
              <perk.icon className="h-5 w-5 text-clay" aria-hidden="true" data-id="element-230" data-mp="3utrgn3ig90mt" />
              <span className="text-[12px] leading-snug text-white/70 sm:text-[12.5px]" data-id="element-231" data-mp="3urnd4mogq3n2">
                {perk.label}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}